import React from 'react'
import "./AboutUs.css"

const AboutUs = () => {
    return (
        <>

            <section id='aboutus'>
                <div className="container-fluid">
                    <div className="CommonPadding">
                        <div className="row g-4 d-flex justify-content-center align-items-center Organic-Food-Section-Main-Heading-Top">
                            <div className="col-xl-6 col-lg-6">
                                <div className='AboutUsMain'>
                                    <img src={require("../Img/HomeSlide1.webp")} alt="" />
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6">
                                <div className='Home-Our-Services-Section-Title'>
                                    <h5>
                                        About Us
                                    </h5>
                                    <h2 style={{ lineHeight: "1.7", fontSize: "17px" }}>
                                        P.A.S. Glam Beauty Studio & Institute is where beauty, creativity, and skill come together.
                                        Founded by Mrs. Pratima Thakur, we aim to help every woman look her best and build confidence through expert beauty services and professional training.
                                        <br />
                                        Our studio blends a modern approach with trusted techniques — offering everything from advanced makeup and hairstyling to certified beautician courses.
                                        At P.A.S. Glam, we believe in quality, care, and continuous learning.
                                        <br />
                                        ✨ Personality According Style — because beauty begins with confidence.
                                    </h2>
                                </div>
                            </div>
                        </div>

                        {/* <div className="row g-4">
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img className='w-100' src={require("../Img/Services1.jpg")} alt="" />
                                    <div className='AbouInfo'>
                                        <h2>
                                            A spa is a location where mineral-rich spring water
                                        </h2>
                                        <p>
                                            May 23, 2021 in
                                            <span>
                                                Spa Treatments
                                            </span>
                                        </p>
                                        <p className='mt-3' style={{ color: "#585858" }}>
                                            The term is derived from the name of the town of Spa, Belgium,
                                            whose name is known back from Roman times, when the
                                            location was called Aquae Spadanae, sometimes incorrectly.
                                        </p>
                                        <button>
                                            <a href="/" className='text-decoration-none'>
                                                Read More
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img className='w-100' src={require("../Img/Services1.jpg")} alt="" />
                                    <div className='AbouInfo'>
                                        <h2>
                                            The main professionals that provide therapeutic
                                        </h2>
                                        <p>
                                            May 23, 2021 in
                                            <span>
                                                Spa Treatments
                                            </span>
                                        </p>
                                        <p className='mt-3' style={{ color: "#585858" }}>
                                            Many types of practices are associated with massage
                                            and include bodywork, manual therapy, energy medicine,
                                            neural mobilization and breathwork. Other names for massage.
                                        </p>
                                        <button>
                                            <a href="/" className='text-decoration-none'>
                                                Read More
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img className='w-100' src={require("../Img/Services1.jpg")} alt="" />
                                    <div className='AbouInfo'>
                                        <h2>
                                            The dyeing of hair is an ancient art that involves
                                        </h2>
                                        <p>
                                            May 23, 2021 in
                                            <span>
                                                Hair Care
                                            </span>
                                        </p>
                                        <p className='mt-3' style={{ color: "#585858" }}>
                                            In ancient times, the dyes were obtained from
                                            plants. Some of the most well known are henna
                                            (Lawsonia inermis), indigo, Cassia obovata, senna, turmeric and amla.
                                        </p>
                                        <button>
                                            <a href="/" className='text-decoration-none'>
                                                Read More
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img className='w-100' src={require("../Img/Services1.jpg")} alt="" />
                                    <div className='AbouInfo'>
                                        <h2>
                                            Beauty salons have proven to be a recession-proof industry
                                        </h2>
                                        <p>
                                            May 23, 2021 in
                                            <span>
                                                Makeup Tips
                                            </span>
                                        </p>
                                        <p className='mt-3' style={{ color: "#585858" }}>
                                            Although sales had declined from 2008 highs due to
                                            the Great Recession, they remain robust
                                            with long term positive forecast.
                                            Even though during recessions, consumers tend.
                                        </p>
                                        <button>
                                            <a href="/" className='text-decoration-none'>
                                                Read More
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img className='w-100' src={require("../Img/Services1.jpg")} alt="" />
                                    <div className='AbouInfo'>
                                        <h2>
                                            Cosmetics that are meant to be used on the face and eye
                                        </h2>
                                        <p>
                                            May 19, 2021 in
                                            <span>
                                                Makeup Tips
                                            </span>
                                        </p>
                                        <p className='mt-3' style={{ color: "#585858" }}>
                                            Abrasive exfoliants include gels, creams or lotions,
                                            as well as physical objects. Loofahs, microfiber
                                            cloths, natural sponges, or brushes may be used to
                                            exfoliate skin simply by rubbing them over the face.
                                        </p>
                                        <button>
                                            <a href="/" className='text-decoration-none'>
                                                Read More
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img className='w-100' src={require("../Img/Services1.jpg")} alt="" />
                                    <div className='AbouInfo'>
                                        <h2>
                                            Aromatherapists, people who specialize in the practice
                                        </h2>
                                        <p>
                                            May 18, 2021 in
                                            <span>
                                                Spa Treatments
                                            </span>
                                        </p>
                                        <p className='mt-3' style={{ color: "#585858" }}>
                                            Oils are described by Dioscorides, along with beliefs
                                            of the time regarding their healing properties,
                                            in his De Materia Medica, written in the first century.
                                            Distilled essential oils have been employed.
                                        </p>
                                        <button>
                                            <a href="/" className='text-decoration-none'>
                                                Read More
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>

        </>
    )
}

export default AboutUs